import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 2fr 4fr 4fr 4fr 1fr',
    gridGap: 20,
    alignItems: 'center',
    padding: '12px 4px',
    marginBottom: 4,
    marginTop: 4
  },
  rootFa: {
    gridTemplateColumns: '2fr 0.5fr 2fr 4fr 4fr 4fr 1fr'
  },
  skeleton: {
    width: '80%'
  }
}))

export default useStyles
